<form nz-form [formGroup]="formGroup" (ngSubmit)="submitForm()">
  <nz-form-item>
    <nz-form-label [nzSpan]="7" nzRequired>Username</nz-form-label>
    <nz-form-control [nzSpan]="14" nzHasFeedback [nzErrorTip]="userErrorTemplate">
      <nz-select
        nz-input
        formControlName="user"
        nzPlaceHolder="Search for a user..."
        [nzDropdownMatchSelectWidth]="true"
        nzShowSearch
        nzServerSearch
        nzSuffixIcon="user"
        (nzOnSearch)="onSearch($event)"
      >
        <nz-option
          *ngFor="let user of optionList; trackBy: trackByRef"
          [nzValue]="{ id: user.id, username: user.shortName }"
          [nzLabel]="user.displayName ?? null"
          nzCustomContent
        >
          <i nz-icon nzType="user"></i>
          <span nz-text>{{ user?.displayName }}</span>
          <span nz-text nzType="secondary">({{ user?.shortName }})</span>
        </nz-option>
        <nz-option *ngIf="isLoading" nzDisabled nzCustomContent>
          <i nz-icon nzType="loading" class="loading-icon"></i>
          Loading Data...
        </nz-option>
        <nz-option *ngIf="errorMsg" nzDisabled nzCustomContent>
          {{ errorMsg }}
        </nz-option>
      </nz-select>

      <ng-template #userErrorTemplate let-control>
        <ng-container *ngIf="control.errors.required">Username is required</ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item>
    <nz-form-control [nzOffset]="7" [nzSpan]="14">
      <button
        nz-button
        nzType="primary"
        [disabled]="!formGroup.valid || isSaving"
        [nzLoading]="isSaving"
      >
        Submit
      </button>
    </nz-form-control>
  </nz-form-item>
</form>
